import React, { Component } from 'react';
import {
  Responsive,
  Sidebar,
  Segment,
  Grid,
  Rail,
  Icon,
} from 'semantic-ui-react';
import Drawing from './Drawing';
import RightMenu from './RightMenu';

const RightMenuPusher = (props) => (
  <Rail
    attached
    position={props.position}
    internal={props.internal}
    className="right-menu-pusher"
  >
    <Segment onClick={props.onClick}>
      <Icon name={props.visible ? 'caret right' : 'caret left'} />
    </Segment>
  </Rail>
);

export default class ResponsiveDrawing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: window.innerWidth > Responsive.onlyTablet.minWidth,
    };
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle = () => this.setState({ visible: !this.state.visible });

  render() {
    const { visible } = this.state;
    return (
      <>
        <Responsive {...Responsive.onlyMobile}>
          <Sidebar.Pushable as={Segment}>
            <Sidebar
              as={Segment}
              animation="overlay"
              icon="labeled"
              vertical
              visible={true}
              className={visible ? 'py0' : 'hide'}
              width="thin"
              direction="right"
            >
              <RightMenu />
              <RightMenuPusher
                position="left"
                onClick={this.handleToggle}
                visible={visible}
              />
            </Sidebar>
            <Sidebar.Pusher style={{ display: 'inline' }}>
              <Drawing />
            </Sidebar.Pusher>
          </Sidebar.Pushable>
        </Responsive>
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Grid>
            <Grid.Row>
              <Grid.Column
                computer={visible ? 12 : 16}
                tablet={visible ? 10 : 16}
              >
                <Drawing />
                <RightMenuPusher
                  position="right"
                  internal
                  onClick={this.handleToggle}
                  visible={visible}
                />
              </Grid.Column>
              {visible ? (
                <Grid.Column computer={4} tablet={6}>
                  <RightMenu />
                </Grid.Column>
              ) : (
                ''
              )}
            </Grid.Row>
          </Grid>
        </Responsive>
      </>
    );
  }
}
